var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-income-details" },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.goPrevious },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("div", { staticClass: "nav-bar-left" }, [
                      _c("img", {
                        staticClass: "left-nav",
                        attrs: {
                          src: require("@/assets/packageAssets/common/arrow05.png"),
                          alt: "",
                        },
                      }),
                      _c("span", { staticClass: "tit-left" }, [
                        _vm._v(_vm._s(_vm.$t("lang.dl.incomeDetails"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "income-details" },
        [
          _c("div", { staticClass: "filter-box" }, [
            _c(
              "div",
              { staticClass: "select-time", on: { click: _vm.handleTimePop } },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.handleMoment(_vm.chooseTime, "YYYY-MM-DD"))
                  ),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow06.png"),
                    alt: "",
                  },
                }),
              ]
            ),
            _c(
              "div",
              { staticClass: "select-type", on: { click: _vm.handleSelete } },
              [
                _vm._v(" " + _vm._s(_vm.activeStatu) + " "),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow06.png"),
                    alt: "",
                  },
                }),
              ]
            ),
          ]),
          _c(
            "van-list",
            {
              staticClass: "income-list",
              attrs: {
                "loading-text": " ",
                "immediate-check": false,
                finished: _vm.isEnd,
                "finished-text": "",
                offset: 300,
              },
              on: { load: _vm.fetchMyBeansDetail },
              model: {
                value: _vm.isLoading,
                callback: function ($$v) {
                  _vm.isLoading = $$v
                },
                expression: "isLoading",
              },
            },
            _vm._l(_vm.data, function (item, index) {
              return _c("div", { key: item }, [
                _c(
                  "div",
                  {
                    staticClass: "list-item",
                    class: { "active-color": item.tip },
                    on: {
                      click: function ($event) {
                        return _vm.handleToggleTip(item, index)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "list-item-left" }, [
                      _c("div", { staticClass: "bill-type" }, [
                        _vm._v(_vm._s(_vm.findBillTypeTxt(item.billType))),
                      ]),
                      _c("div", { staticClass: "bill-time" }, [
                        _vm._v(
                          _vm._s(
                            _vm.handleMoment(
                              item.createTime,
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "list-item-right" }, [
                      _c("div", { staticClass: "bill-content" }, [
                        _c("div", { staticClass: "bill-beans" }, [
                          _c("img", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.tip,
                                expression: "item.tip",
                              },
                            ],
                            staticClass: "bill-q",
                            attrs: {
                              src: require("@/assets/packageAssets/views/P1_Girls/MyBeans/vava/question.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                item.changeAmount > 0
                                  ? "+" + item.changeAmount
                                  : item.changeAmount
                              ) +
                              " "
                          ),
                          _c("img", {
                            staticClass: "bill-b",
                            attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                          }),
                        ]),
                        _c("div", { staticClass: "bill-from" }, [
                          _vm._v(_vm._s(item.fromName)),
                        ]),
                      ]),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.tip,
                            expression: "item.tip",
                          },
                        ],
                        staticClass: "bill-arrow",
                        class: { "arrow-down": !item.tipShow },
                        attrs: {
                          src: require("@/assets/packageAssets/common/arrow08.png"),
                          alt: "",
                        },
                      }),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.tipShow,
                        expression: "item.tipShow",
                      },
                    ],
                    staticClass: "tips-item",
                  },
                  [
                    _c("p", { staticClass: "tips-tit" }, [
                      _vm._v(_vm._s(_vm.$t("lang.dl.incomeDetails"))),
                    ]),
                    _c("p", { staticClass: "tips-text" }, [
                      _vm._v(_vm._s(item.tip)),
                    ]),
                  ]
                ),
              ])
            }),
            0
          ),
        ],
        1
      ),
      _c("CTimeDay", {
        attrs: { showPop: _vm.showPop },
        on: { handleCurrentDate: _vm.handleCurrentDate },
      }),
      _c("Selete", {
        attrs: {
          defaultIndex: _vm.defaultIndex,
          columns: _vm.incomeType,
          showPop: _vm.showSelete,
        },
        on: { currentChoose: _vm.currentChoose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }